import { render, staticRenderFns } from "./OrganizationStructureView.vue?vue&type=template&id=71957d35"
import script from "./OrganizationStructureView.vue?vue&type=script&lang=js"
export * from "./OrganizationStructureView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports